import React from 'react';
import { MapPin, Send, Clock } from 'lucide-react';
import { jobVacancies, companyInfo } from '../data/mock';

const Careers = () => {
  const handleApply = (jobTitle) => {
    const subject = encodeURIComponent(`Application for ${jobTitle} - SaraPrivéAviation`);
    const body = encodeURIComponent(`Dear SaraPrivéAviation Team,\n\nI am writing to express my interest in the ${jobTitle} position.\n\nPlease find my CV attached.\n\nBest regards,`);
    window.location.href = `mailto:${companyInfo.email}?subject=${subject}&body=${body}`;
  };

  return (
    <section id="careers" className="py-24 lg:py-32 bg-[#f5f0e8]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-16 lg:mb-20">
          <span className="text-xs tracking-[0.3em] uppercase text-[#c9b896] mb-4 block">
            Join Our Elite Team
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-[#2c2825] mb-6" style={{ fontWeight: 400 }}>
            Current Opportunities
          </h2>
          <div className="w-16 h-px bg-[#c9b896] mx-auto mb-8" />
          <p className="text-base text-[#5a5652] max-w-2xl mx-auto">
            Discover exclusive positions in VVIP and corporate aviation based in Riyadh. Submit your CV to join our network of elite professionals.
          </p>
        </div>

        {/* Job Cards */}
        <div className="space-y-6 mb-16">
          {jobVacancies.map((job) => (
            <div
              key={job.id}
              className="group bg-[#faf8f5] p-8 lg:p-10 border border-transparent hover:border-[#c9b896] transition-all duration-300"
            >
              <div className="flex flex-col lg:flex-row lg:items-start justify-between gap-6">
                <div className="flex-1">
                  <div className="flex flex-wrap items-center gap-4 mb-4">
                    <span className="text-xs tracking-widest uppercase text-[#c9b896] px-3 py-1 border border-[#c9b896]">
                      {job.type}
                    </span>
                    <span className="flex items-center gap-2 text-sm text-[#5a5652]">
                      <MapPin size={14} strokeWidth={1.5} />
                      {job.location}
                    </span>
                    <span className="flex items-center gap-2 text-sm text-[#5a5652]">
                      <Clock size={14} strokeWidth={1.5} />
                      {job.rotation}
                    </span>
                  </div>
                  <h3 className="font-display text-xl lg:text-2xl text-[#2c2825] mb-4" style={{ fontWeight: 500 }}>
                    {job.title}
                  </h3>
                  <div className="mt-4">
                    <span className="text-xs tracking-widest uppercase text-[#c9b896] mb-2 block">
                      Role Description
                    </span>
                    <p className="text-sm text-[#5a5652] leading-relaxed max-w-3xl">
                      {job.description}
                    </p>
                  </div>
                  {job.qualifications && (
                    <div className="mt-6">
                      <span className="text-xs tracking-widest uppercase text-[#c9b896] mb-3 block">
                        Qualifications
                      </span>
                      <ul className="space-y-2">
                        {job.qualifications.map((qual, index) => (
                          <li key={index} className="text-sm text-[#5a5652] leading-relaxed flex items-start gap-3">
                            <span className="text-[#c9b896] mt-1">•</span>
                            {qual}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
                <div className="flex-shrink-0 lg:mt-6">
                  <button
                    onClick={() => handleApply(job.title)}
                    className="inline-flex items-center gap-3 px-8 py-4 border border-[#2c2825] text-[#2c2825] text-sm tracking-widest uppercase hover:bg-[#2c2825] hover:text-[#faf8f5] transition-all duration-300"
                  >
                    Apply Now
                    <Send size={16} strokeWidth={1.5} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* General Application CTA */}
        <div className="text-center bg-[#2c2825] p-12 lg:p-16">
          <h3 className="font-display text-2xl lg:text-3xl text-[#faf8f5] mb-4" style={{ fontWeight: 400 }}>
            Don't see your ideal position?
          </h3>
          <p className="text-base text-[#faf8f5]/80 mb-8 max-w-xl mx-auto">
            We're always looking for exceptional talent. Send us your CV and we'll keep you in mind for future opportunities.
          </p>
          <a
            href={`mailto:${companyInfo.email}?subject=General CV Submission - SaraPrivéAviation`}
            className="inline-flex items-center gap-3 px-10 py-4 bg-[#c9b896] text-[#2c2825] text-sm tracking-widest uppercase hover:bg-[#d4c4a8] transition-all duration-300"
          >
            Send Your CV Now
            <Send size={16} strokeWidth={1.5} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Careers;
